export const VOCAL_DISCOVERY_PRODUCT_KEY = "vocal_discovery_package" as const;
export const VOCAL_DISCOVERY_DISPLAY_NAME = "Vocal Discovery Package" as const;
export const VOCAL_DISCOVERY_AMOUNT_PENCE = 34_900;
export const VOCAL_DISCOVERY_CURRENCY = "gbp" as const;

export const PACKAGE_LOCATIONS = ["ely", "bury_st_edmunds", "either"] as const;

export type PackageLocation = (typeof PACKAGE_LOCATIONS)[number];

export function isPackageLocation(value: unknown): value is PackageLocation {
  return typeof value === "string" && (PACKAGE_LOCATIONS as readonly string[]).includes(value);
}

export function getPackageLocationLabel(location: PackageLocation) {
  if (location === "ely") return "Ely";
  if (location === "bury_st_edmunds") return "Bury St Edmunds";
  return "Either location";
}
